import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };

class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
	    const cateId = (typeof this.props.params.ID === 'undefined') ? '' : this.props.params.ID;
		this.state = {
            cateId: cateId,
			category:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'',
			memb_cat_for_selectedOption:{ value: 'company', label: 'Company'},
			memb_cat_for_selectedvalue:'company'
		};
		// this.props.getCategoryDetailList(cateId);
		var qs = require('qs');
		var catid = this.state.cateId;

		axios.get(apiUrl+"MembershipCategory/listdetail?id="+catid).then(res => {
			this.setState({category:res.data.categorylist.category});
			if(res.data.categorylist.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
			this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}
			if(res.data.categorylist.category_for !== ''){
				const cat_for_label_value = lang.common.memb_cat_for_option.find(
					opt => opt.value === res.data.categorylist.category_for
					);

				this.setState({ memb_cat_for_selectedOption: cat_for_label_value,memb_cat_for_selectedvalue:res.data.categorylist.category_for});
			}
			
		}); 		
		
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);

    }

	handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}else if(r == 'memb_cat_for'){
			this.setState({memb_cat_for_selectedOption:selOption})
			this.setState({memb_cat_for_selectedvalue : selOption.value});
		}
 	};
   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
     		
    }


	componentDidMount() {
		document.category = PageTitle('Membership Category Edit');
    }

	
        handleFormSubmit = () => {
			if(this.validateForm()){ 
				this.setState({Loading:true});
				const formPayload = this.state;
				var qs = require('qs');
				var status = '';
				var memb_cat_for = '';
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
				}else{
				status = formPayload.selectedvalue;
				}
				if(formPayload.memb_cat_for_selectedvalue === ''){
				memb_cat_for = formPayload.memb_cat_for_selectedOption.value;
				}else{
				memb_cat_for = formPayload.memb_cat_for_selectedvalue;
				}

				var postObject = {
					admin_id : localStorage.getItem("admin_id"),
					category: formPayload.category,
					status:  status,
					memb_cat_for:memb_cat_for,
					id: formPayload.cateId				
				};

				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}		       
				axios.post(apiUrl+"MembershipCategory/edit",formData ).then(res => {
					if(res.data.status === "success"){
						this.setState({Loading:false});
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
								setTimeout(
								function() {
									//$('.success_message').html('');
									$('.success_message').html(this.props.navigate('/membershipcategory'));
								}
								.bind(this),
								3000
								);
					}else{
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
						this.setState({Loading:false});
					}
				});
			}
	}

	validateForm() {
		const {category} = this.state;
		const nameRegex = /^[A-Za-z\s.]+$/;

		let errors = {};
		  let formIsValid = true;
	
		  if (!category) {
			formIsValid = false;
			$('.errorcategory').html('<span class="errorspan">Please fill the field</span>');
		}else if(category){
			if (!nameRegex.test(category)) {
				formIsValid = false;
			$('.errorcategory').html('<span class="errorspan">Please enter the valid Category</span>');
			}else{
				$('.errorcategory').html('');
			}
			
		}
			
		this.setState({
			errors: errors
		});
		return formIsValid;
	}
  render() {

  	  const {selectedOption,memb_cat_for_selectedOption} = this.state;	


  	
    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="MembershipCategory"  currentTab="common" currentSubTab="membership-management" />  
      <div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a class="primary-btn" href="/membershipcategory">Back</a>
			</div>
			<div className="title">
				<h4>Edit Membership Category</h4>
			</div>
			 <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Category Name<span class="required" style={{ color: "red" }} > * </span>  </label>
				    <input type="text" name="category" onChange={this.handleInputChange} className="form-control" value={this.state.category} />
					<div className="errorcategory"></div>
				</div>	

				<div className="form-group">					
					<label>Category For<span class="required" style={{ color: "red" }} > * </span></label>
							<Select 
							name="memb_cat_for"
							value={memb_cat_for_selectedOption?memb_cat_for_selectedOption:{ value: 'company', label: 'Company'}}
							options={lang.common.memb_cat_for_option} 
							isSearchable = {false}
							onChange={this.handleChange.bind(this, 'memb_cat_for')}
							/>
				</div>		
			</div>
                  
			<div className="form-right">

               <div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} > * </span> </label>
						   <Select 
						   value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
                            options={lang.common.status_option} 
                            onChange={this.handleChange.bind(this, 'status')}
                            />
	           </div> 

			</div>	
			</div>		



			<div className="btn-group export">	
				  <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true?
                                        <span>updating</span>:<span>Submit</span>
                                        }
                   </button>
			</div>
			</form>
			</div>				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default (withRouter(Edit));